import { render, staticRenderFns } from "./LineItemTurtle.vue?vue&type=template&id=630cf5f2&"
import script from "./LineItemTurtle.vue?vue&type=script&lang=js&"
export * from "./LineItemTurtle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports